import React, { useState } from 'react';
import { FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { axiosInstance } from '../lib/axio';

const ContactUs = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const contactUsHandle = async (e) => {
        e.preventDefault();
        try {
            setTimeout(() => {
                setIsSubmitted(true); 
                setFirstName('');
                setLastName('');
                setEmail('');
                setMessage('');
                setError(null);
            }, 500)

            await axiosInstance.post('/send-contactus-response', {
                firstName,
                lastName,
                email,
                message,
            });

        } catch (err) {
            console.error('Error sending email:', err);
            setError('Failed to send your message. Please try again later.');
        }
    };

    return (
        <div className="text-white relative min-h-screen flex flex-col items-center justify-center p-8">
            {/* Overlay */}
            <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
            {/* Background Image */}
            <div className="absolute inset-0 bg-[url('https://res.cloudinary.com/devw55qwa/image/upload/fl_preserve_transparency/v1737440165/WhatsApp_Image_2025-01-20_at_13.23.29_9e8cc1ac_yjf6ag.jpg')] bg-cover bg-center bg-no-repeat"></div>

            <div className="relative z-20 max-w-2xl w-full flex flex-col items-start mt-[5%]">
                <h1 className="text-5xl font-bold mb-4 poppins-medium">Get in touch.</h1>
                <p className="my-8 poppins-light text-base leading-8">
                    Got a book you’re dying to rave about? A story that needs a little extra love? Or maybe you just want to say hello (we do love a well-written letter)? Drop us a line!

                </p>
                <p className="mt-0 my-8 poppins-light text-base leading-8">
                    Guest Submissions: We welcome guest posts, reviews, and indie author spotlights. Pitch us your ideas, and let’s create something beautiful together.

                    We’re always open to whispers of great stories, collaboration ideas, and passionate bookish chatter.
                    Slide into our inbox—our DMs are open, and so are our hearts. Let’s talk books!
                </p>

                <div className="mb-6 poppins-medium text-[19px]">
                    <div className="my-8">
                        <p className="font-medium">itsbooklore@gmail.com</p>
                        {/* <p className="font-medium">(555) 555-5555</p> */}
                    </div>
                    {/* <div>
                        <p className="font-medium">123 Demo Street</p>
                        <p className="font-medium">New York, NY 12345</p>
                    </div> */}
                </div>
                <div className="flex gap-4 text-xl">
                    <Link to="https://www.instagram.com/itsbooklore/" target="_blank">
                        <FaInstagram className="hover:text-[#d62976] transition-all" />
                    </Link>
                    <Link to="https://www.youtube.com/@readatbooklore" target="_blank">
                        <FaYoutube className="hover:text-red-500 transition-all" />
                    </Link>
                    <Link to="https://x.com/itsbooklore" target="_blank">
                        <FaTwitter className="hover:text-blue-400 transition-all" />
                    </Link>
                    <Link to="https://www.linkedin.com/company/booklore-in/" target="_blank">
                        <FaLinkedin className="hover:text-[#0077b5] transition-all" />
                    </Link>

                </div>

                {/* Conditional rendering for thank-you message or form */}
                {isSubmitted ? (
                    <div className="text-center mt-14">
                        <h2 className="text-3xl font-bold mb-4">Thank you for contacting us!</h2>
                        <p className="text-lg">
                            We appreciate you reaching out. Our team will get back to you shortly.
                        </p>
                    </div>
                ) : (
                    <form className="rounded-lg w-full mt-14  font-bold" onSubmit={contactUsHandle}>
                        <label className="block py-2">Name <span className="text-white">(required)</span></label>
                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <div>
                                <label className="block mb-2">First Name</label>
                                <input
                                    type="text"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className="text-black w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f3a294]"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block mb-2">Last Name</label>
                                <input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className="text-black w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f3a294]"
                                    required
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2">Email <span className="text-white">(required)</span></label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="text-black w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f3a294]"
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2">Message <span className="text-white">(required)</span></label>
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                className="text-black w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#f3a294]"
                                rows="4"
                                required
                            ></textarea>
                        </div>
                        {error && (
                            <p className="text-red-500 mb-4">{error}</p>
                        )}
                        <button
                            type="submit"
                            className="w-full hover:bg-[#ff0062] bg-[#ff0062b7] text-white py-2 rounded-lg font-bold"
                        >
                            Send
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ContactUs;
